import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  startDateTitle: {
    id: 'course-authoring.course-outline.status-bar.start-date',
    defaultMessage: 'Start date',
  },
  pacingTypeTitle: {
    id: 'course-authoring.course-outline.status-bar.pacing-type',
    defaultMessage: 'Pacing type',
  },
  pacingTypeSelfPaced: {
    id: 'course-authoring.course-outline.status-bar.pacing-type.self-paced',
    defaultMessage: 'Self-paced',
  },
  pacingTypeInstructorPaced: {
    id: 'course-authoring.course-outline.status-bar.pacing-type.instructor-Paced',
    defaultMessage: 'Instructor-paced',
  },
  checklistTitle: {
    id: 'course-authoring.course-outline.status-bar.checklists',
    defaultMessage: 'Checklists',
  },
  checklistCompleted: {
    id: 'course-authoring.course-outline.status-bar.checklists.completed',
    defaultMessage: 'completed',
  },
  notificationMetadataTitle: {
    id: 'course-authoring.course-outline.status-bar.notification-metadata',
    defaultMessage: '{count, plural, one {{count} notification} other {{count} notifications}}',
    description: 'Metadata notifications text in course outline',
  },
  highlightEmailsButton: {
    id: 'course-authoring.course-outline.status-bar.highlight-emails.button',
    defaultMessage: 'Enable highlights emails',
    description: 'Enable highlights emails button in course outline',
  },
  highlightEmailsEnabled: {
    id: 'course-authoring.course-outline.status-bar.highlight-emails.enabled',
    defaultMessage: 'Highlights emails enabled',
    description: 'Message displayed when highlights emails are enabled',
  },
  courseTagsTitle: {
    id: 'course-authoring.course-outline.status-bar.course-tags',
    defaultMessage: 'Course tags',
    description: 'Course tags header in course outline',
  },
  courseManageTagsLink: {
    id: 'course-authoring.course-outline.status-bar.course-manage-tags-link',
    defaultMessage: 'Manage tags',
    description: 'Opens the drawer to edit content tags',
  },
  videoSharingTitle: {
    id: 'course-authoring.course-outline.status-bar.video-sharing.title',
    defaultMessage: 'Video Sharing:',
  },
  videoSharingLink: {
    id: 'course-authoring.course-outline.status-bar.video-sharing.link',
    defaultMessage: 'Learn more',
  },
  videoSharingPerVideoText: {
    id: 'course-authoring.course-outline.status-bar.video-sharing.perVideo.text',
    defaultMessage: 'Per Video',
  },
  videoSharingAllOffText: {
    id: 'course-authoring.course-outline.status-bar.video-sharing.allOff.text',
    defaultMessage: 'No Videos',
  },
  videoSharingAllOnText: {
    id: 'course-authoring.course-outline.status-bar.video-sharing.allOn.text',
    defaultMessage: 'All Videos',
  },
  unpublishedBadgeText: {
    id: 'course-authoring.course-outline.status-bar.unpublished.badge.text',
    defaultMessage: 'Unpublished Changes',
    description: 'Text in badge displayed in course outline if course has unpublished changes.',
  },
  activeBadgeText: {
    id: 'course-authoring.course-outline.status-bar.active.badge.text',
    defaultMessage: 'Active',
    description: 'Active Badge shown in course outline when the course is active, i.e., course has started and not ended yet.',
  },
  archivedBadgeText: {
    id: 'course-authoring.course-outline.status-bar.archived.badge.text',
    defaultMessage: 'Archived',
    description: 'Archived Badge shown in course outline when the course is archived, i.e., ended',
  },
  upcomingBadgeText: {
    id: 'course-authoring.course-outline.status-bar.upcoming.badge.text',
    defaultMessage: 'Upcoming',
    description: 'Upcoming Badge shown in course outline when the course has not started yet.',
  },
  libraryUpdatesText: {
    id: 'course-authoring.course-outline.status-bar.library.updates.text',
    defaultMessage: '{count, plural, one {{count} Library Update} other {{count} Library Updates}}',
    description: 'Status text displaying count of library updates',
  },
});

export default messages;
